import ReactInputRange from "components/MultiRangeSlider/ReactInputRange";
import ReactInputSimpleSlider from "components/MultiRangeSlider/ReactInputSimpleSlider";
import { VehicleContext } from "context/vehicleContext";
import { FiltersDB } from "models/filtersDB";
import { useEffect, useState, useContext } from "react";
import { numberWithCommas, numberWithCommasAndSymbol } from "utils/commonUtils";

const FilterSlider = ({
    // data,
    typeName,
    show,
    label,
    useCommas = true,
    step = 1,
}: any) => {
    const { currentState: stateContext, setSelectedItemInSlider } = useContext(VehicleContext);
    const { filtersData } = stateContext;

    const data = filtersData?.find((c: FiltersDB) => c.typeName.toLowerCase() === typeName.toLowerCase());

    const ranges = data?.keyName?.split("|") ?? [0, 0];

    const minSelected = Number((ranges?.[0] < 0 ? 0 : ranges?.[0]) ?? 0);
    const maxSelected = Number((ranges?.[1] < 0 ? 0 : ranges?.[1]) ?? 0);

    const getSliderLabel = (minSelected: number, maxSelected: number) => {
        const labelMin = useCommas ? getRangeValue(typeName, minSelected) : minSelected;
        const labelMax = useCommas ? getRangeValue(typeName, maxSelected) : maxSelected;
        return typeName === 'miles' ? `${label}: ${labelMax} or fewer` : `${label}: ${labelMin} - ${labelMax}`;
    };
    
    const getRangeValue = (typeName: string, value: number) => {
        return typeName?.toLowerCase()?.includes('price') ? numberWithCommasAndSymbol(Number(value)) : numberWithCommas(Number(value));
    };

    const initialState = {
        minSelected,
        maxSelected,
        labelSlider: getSliderLabel(minSelected, maxSelected)
    };

    const [currentState, setCurrentState] = useState(initialState);

    const changeLabel = (min: number, max: number) => {
        const newLabel = getSliderLabel(min, max);
        setCurrentState({
            ...currentState,
            labelSlider: newLabel,
        });
        const { minSelected, maxSelected } = currentState;
        if(minSelected !== min || maxSelected !== max){
            const newLabel = getSliderLabel(min, max);
            setCurrentState({
                ...currentState,
                labelSlider: newLabel,
            });
        }
    };

    useEffect(() => {
        if (data) {
            const ranges = data?.keyName?.split("|") ?? [0, 0];
            const dataMin = Number((ranges?.[0] < 0 ? 0 : ranges?.[0]) ?? 0);
            const dataMax = Number((ranges?.[1] < 0 ? 0 : ranges?.[1]) ?? 0);
            
            setCurrentState({
                ...currentState,
                minSelected: dataMin,
                maxSelected: dataMax,
            });
            // }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <div className={`col-md-12 paymentsliderdiv ${show ? "" : "hidden"}`}>
            {currentState.minSelected === 0 && currentState.maxSelected === 0 &&
                <span className="skeleton skeleton-glow col-md-12" />
            }
            {currentState.minSelected >= 0 && currentState.maxSelected > 0 &&
            <>
                <div className="selectedpricetextslider col-md-12">
                    {currentState.labelSlider}
                </div>
                {typeName ==='miles' && <ReactInputSimpleSlider typeName={typeName}
                    minVal={Number(currentState.minSelected)}
                    maxVal={Number(currentState.maxSelected)}
                    onSetLabel={({ min, max }: { min: number; max: number }) => {
                        changeLabel(min, max);
                    }}
                    step={step}
                    onChange={({ max }: { max: number }) => {
                        setSelectedItemInSlider(typeName, ['0', String(max)], data, false);
                    }}
                />}
                {typeName !=='miles' && <ReactInputRange
                    typeName={typeName}
                    minVal={Number(currentState.minSelected)}
                    maxVal={Number(currentState.maxSelected)}
                    onSetLabel={({ min, max }: { min: number; max: number }) => {
                        changeLabel(min, max);
                    }}
                    step={step}
                    onChange={({ min, max }: { min: number; max: number }) => {
                        if (typeName === 'miles') setSelectedItemInSlider(typeName, ['0', String(max)], data, false);
                        else setSelectedItemInSlider(typeName, [String(min), String(max)], data, false);
                    }}
                />
                }
            </>
            }
        </div>
    );
};

// const equal = (prevProps: any, nextProps: any) => {
//     return prevProps.data === nextProps.data
//     && prevProps.show === nextProps.show;
// };

export default FilterSlider; // memo(FilterSlider, equal);
